import React from 'react';
import './myutils';
import {
    Datagrid,
    DisabledInput,
    Edit,
    EditButton,
    List,
    Responsive,
    ShowButton,
    SimpleForm,
    SimpleList,
    TextField,
    TextInput,
    Toolbar,
    SaveButton,
} from 'react-admin';
import CardField from './res/CardField';
import { withStyles } from '@material-ui/core';
var bg = require('./res/yemot.gif');

const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};

const PostEditActions = withStyles(toolbarStyles)(props => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
));

export const ProfileList = (props) => (
    <List
    {...props}
    actions={<PostEditActions />}
    sort={{ field: 'published_at', order: 'DESC' }}
>
    <Responsive
        small={
            <SimpleList
                primaryText={record => record.title}
                secondaryText={record => `${record.views} views`}
                tertiaryText={record =>
                    new Date(record.published_at).toLocaleDateString()}
            />
        }
        medium={
            <Datagrid>
                <TextField source="username" label='resources.profile.username'/>
                <TextField source="name"  />
                <TextField source="email"  type="email" />
                <TextField source="fax"  />
                <TextField source="phones" />
                <TextField source="organization" />
                <TextField source="contactName" />
                <TextField source="accessPassword"/>
                <TextField source="recordPassword"/>
                <EditButton />
                <ShowButton />
            </Datagrid>
        }
    />
</List>
);

export const ProfileEdit = (props, {translate}, classes) => (
    <Edit  {...props}>
        <SimpleForm toolbar ={<PostEditActions />} redirect="edit">
        <CardField title="trans.UserID" subtitle="trans.organization" titleData="username" subtitleData="organization" link={'/Profile/1'} icon={bg}/>
        <div style={{display: 'flex' }}>
                <div style={{flex: 10, marginRight: '1em'}}>
                <DisabledInput source="username" label='resources.profile.username'/>
                <TextInput source="name"  label='resources.profile.name'/>
                <TextInput source="email"  type="email" label='resources.profile.email'/>
                <TextInput source="fax"  label='resources.profile.fax'/>
                <TextInput source="phones" label='resources.profile.phones'/>
                </div>
                <div style={{flex: 10, marginLeft: '1em', maxWidth: '50%'}}></div>
                <div style={{flex: 10, marginLeft: '1em', maxWidth: '50%'}}>
                <TextInput source="organization" label='resources.profile.organization'/>
                <TextInput source="contactName" label='resources.profile.contactName'/>
                <TextInput source="accessPassword" label='resources.profile.accessPassword'/>
                <TextInput source="recordPassword" label='resources.profile.recordPassword'/>
            </div>
        </div>
        </SimpleForm>
    </Edit>
);


